declare const gtag: any;

export class Analytics {
  static gaLabel = (<any>window).GA_LABEL || 'V1';

  static recordEvent(page: string, event: string, value?: string, otherOptions: any = {}) {
    if ((typeof gtag !== 'undefined')) {
      gtag('event', event, {
        'event_category': page,
        'event_label': Analytics.gaLabel,
        'value': value,
        ...otherOptions
      });
    }
  }
}
